import { http } from 'services/http';
import type { CargoRes, CreateCargoReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useCreateCargo = () => {
  return useMutationBase<CargoRes, unknown, CreateCargoReq>({
    mutationFn: async (variables) => {
      const res = await http.post<CargoRes>('/v1/cargo', variables);

      return res.data;
    },
  });
};
